// i18nUtils.ts - Internationalization utilities for chunked uploaders
import i18n from '../../../../i18n';

/**
 * Translate a message key from backend using i18n
 * @param messageKey - The translation key from backend
 * @param messageParams - Optional parameters for interpolation
 * @param fallbackMessage - Fallback message if translation not found
 * @param namespaceWithPrefix - Namespace with key prefix (e.g., 'dataCloud.processingMessages')
 */
export function translateMessage(
  messageKey: string | undefined,
  messageParams?: Record<string, unknown>,
  fallbackMessage?: string,
  namespaceWithPrefix: string = 'dataProcessing.processingMessages'
): string {
  if (!messageKey) {
    return fallbackMessage || '';
  }

  // Parse namespace and key prefix
  // Format: 'dataProcessing.processingMessages' -> ns='dataProcessing', keyPrefix='processingMessages'
  const dotIndex = namespaceWithPrefix.indexOf('.');
  const ns = dotIndex > 0 ? namespaceWithPrefix.substring(0, dotIndex) : namespaceWithPrefix;
  const keyPrefix = dotIndex > 0 ? namespaceWithPrefix.substring(dotIndex + 1) : '';

  // Build the full key (e.g., 'processingMessages.fp_interpolation_progress')
  const fullKey = keyPrefix ? `${keyPrefix}.${messageKey}` : messageKey;

  // Use proper i18next namespace syntax
  const translated = i18n.t(fullKey, {
    ns,
    ...messageParams as Record<string, string>
  }) as string;

  // If translation found, return it
  if (translated !== fullKey) {
    return translated;
  }

  // Return fallback message or the key itself
  return fallbackMessage || messageKey;
}


